import React, { useEffect, useState } from "react";
import { auth, deleteVenue, getVenue, createVenue,  } from "../functions/firebaseFunctions";
import { FiXSquare, FiCheckSquare, FiEdit, FiXCircle, FiPlusCircle, FiCheckCircle, FiPlusSquare } from 'react-icons/fi'
import Alert from "../Components/Alert";
import { useParams, useNavigate } from "react-router-dom";
import PlaceSearch from "../Components/PlaceSearch";
import { v4 as uuidv4 } from 'uuid';

import { db, storage } from '../functions/firebaseFunctions'

export default function EditVenuePage() {
    const { venueId } = useParams();
    const [user, setUser] = useState(null); // user info from Auth
    const [placeId, setPlaceId] = useState(null);
    const [venue, setVenue] = useState(null);
    const [alert, setAlert] = useState(null);
    const [changes, setChanges] = useState(false);
    const [Err, setErr] = useState(null);
    const [fileInput, setFileInput] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [selImg, setSelImg] = useState(null);
    const fileName = uuidv4();

    const navigateTo = useNavigate();
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            getVenue(venueId).then((getVenueRes) => {
                setVenue(getVenueRes);
                // setImages(venue?.image)
                // console.log('getVenues', getVenueRes)
            }).catch(error => { console.error(error); })
            setUser(user);
        });
        return unsubscribe;
    }, []);

    const uploadImage = async (cover) => {
        try {
            const blob = new Blob([cover.files[0]], { type: cover.files[0].type });
            const storageRef = storage.ref(`venue/${venueId}/cover`);
            const snapshot = await storageRef.put(blob);
            const downloadUrl = await snapshot.ref.getDownloadURL();
            
            const venueRef = db.collection('venue').doc(venueId);
            await venueRef.update({ cover: downloadUrl });

            console.log('Image uploaded successfully!');
        } catch (error) {
            console.error('Error uploading image:', error);
            // setErr(error);
        }
    };

    const addImage = async (img) => {
        try {
            // const ref = db.collection('venue').doc(venueId).get()
            // console.log('ref', (await ref).data())
            const blob = new Blob([img.files[0]], { type: img.files[0].type });
            const storageRef = storage.ref(`venue/${venueId}/${fileName}`);
            const snapshot = await storageRef.put(blob);
            const downloadUrl = await snapshot.ref.getDownloadURL();
            
            // get the current value of the image array from the database
            const venueRef = db.collection('venue').doc(venueId);
            const venueDoc = await venueRef.get();
            const currentImages = venueDoc.data().image || [];
            console.log('venueDoc.data().image', venueDoc.data().image)
            console.log('currentImages',currentImages, 'downloadUrl', downloadUrl)
    
            // add new image to array
            const updatedImages = [...currentImages, downloadUrl];
            console.log('updatedImages', updatedImages)
    
            // update the image array in the database
            await venueRef.update({ image: updatedImages });
    
            console.log('Image add successfully!'); setShowAdd(false);
        } catch (error) {
            console.error('Error uploading image:', error);
            setErr(error);
        }
    }

    const editVenue = async (event) => {
        event.preventDefault();
        const cover = event.target.querySelector('#cover');
        const img = event.target.querySelector('#img');
        console.log('cover', cover, 'img', img)
        cover && uploadImage(cover);
        img && addImage(img)

        const { value: name } = document.querySelector('#name');
        const { value: address } = document.querySelector('#address');
        const { value: desc } = document.querySelector('#desc');
        const { value: price } = document.querySelector('#price');

        const update = {
            name: name ? name : null,
            address: address ? address : null,
            desc: desc ? desc : null,
            price: price ? price : null
        };

        const ref = db.collection('venue').doc(venueId);

    try {
        await ref.update(update);
        setChanges(false);
        console.log('changes are saved');
    } catch (e) {
        setErr(e);
        console.error(e);
    }
    }

    if (!user) {
        return <div
            style={{
                width: '100vw',
                height: '100vh',
                display: 'grid',
                placeItems: 'center',
                color: 'white',
                fontSize: 32
            }}
        >Loading...</div>;
    } else {
        return (
            <div className='EventScreen' style={{flexDirection: 'column'}} >
                <div className="EditVenuePage">
                {Err && <div style={{ color: 'red' }}><p style={{ color: 'red' }}>{Err.message}</p></div>}
                {venue?.cover && <img alt='cover_img'
                    src={venue?.cover}
                    style={{ height: 180, width: '100%', alignSelf: 'center', objectFit: 'cover', }}
                />}
                    {alert && (
                        <Alert
                            title={alert.title}
                            setAlert={setAlert}
                            comment={alert.comment}
                            options={alert.options}
                        />
                    )}
                    {venueId == 'new' && (
                        <PlaceSearch
                        style={{ padding: 10 }}
                        searchType="address"
                        // select={select}
                        setErr={setErr}
                        />
                    )}
                    <div
                        style={
                            { maxWidth: 600, alignSelf: 'center', width: '100%' }
                        }
                    >
                        <div
                            style={{ flex: 1, flexDirection: 'column', display: 'flex' }}
                            behavior="padding"
                        // keyboardVerticalOffset=x
                        >
                            {venue?.cover && (
                                <React.Fragment>
                                    <div style={{
                                        position: 'absolute',
                                        top: 50,
                                        alignSelf: 'center',
                                        display: 'flex',
                                        flexDirection: 'row'
                                    }}>
                                        <button
                                            // type='submit'
                                            style={{
                                                backgroundColor: 'var(--drg)',
                                                borderRadius: 5,
                                                zIndex: 2, 
                                                color: 'white',
                                                display: 'flex',
                                                alignItems:'center', 
                                                borderWidth: 0,
                                                fontSize: 18
                                            }}
                                            onClick={() => {
                                                fileInput ? setFileInput(false) : setFileInput(true)
                                            }}
                                        >
                                            Change Cover Image <FiEdit style={{marginInlineStart: 10,}}/>
                                        </button>
                                        <button
                                            type='submit'
                                            style={{
                                                color: 'var(--red)',
                                                // width: 40,
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                borderWidth: 0,
                                                fontSize: 18,
                                                backgroundColor: 'var(--drg)',
                                                borderRadius: 5,
                                                left: '-10px',
                                                position: 'relative',
                                                zIndex: 2,
                                                paddingInlineStart: 10,
                                            }}
                                        >
                                            <FiXCircle />
                                        </button>
                                    </div>
                                </React.Fragment>
                            )}
                            {venueId != 'new' && !venue?.cover && (
                                <button
                                    type='submit'
                                    style={{ borderWidth: 0, alignSelf: 'center', color: 'white' }}
                                >
                                    Add cover image <FiPlusSquare />
                                </button>
                            )}
                            {venueId != 'new' ? (
                                <React.Fragment>
                                    <form onSubmit={editVenue} style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                                        {fileInput && <label htmlFor="cover" style={{}}>
                                            {/* Choose a cover image: */}
                                            <input
                                            style={{ width: 'auto', height: 'auto' }}
                                            onBlur={coverInput=>{console.log(coverInput.target, '(', coverInput.target.value.length,')',  'changes:', changes, ); coverInput.target.value.length !== 0 ? setChanges(true) : setChanges(false)}}
                                            type="file"
                                            id="cover"
                                            name="cover"
                                            accept="image/png, image/jpeg">
                                            </input>
                                        </label>}
                                        <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                                        <div style={{ paddingInline: 10 }}>
                                            <label htmlFor="name" className="label">
                                                Venue Name:
                                                <input
                                                    name='name'
                                                    id='name'
                                                    className="editable"
                                                    defaultValue={venue?.name && venue.name}
                                                    placeholder={venue?.name ? venue.name : "Enter Venue Name"}
                                                    onBlur={nameInput => {console.log(venue.name); nameInput.target.value !== venue.name && setChanges(true); console.log(changes)}}
                                                />
                                            </label>
                                        </div>
                                        <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                                        <div style={{ paddingInline: 10 }}>
                                            <label htmlFor="address" className="label">
                                                Venue address:
                                                <input
                                                    name='address'
                                                    id='address'
                                                    placeholder="Enter Venue address"
                                                    className="editable"
                                                    defaultValue={venue?.address && venue.address}
                                                    onBlur={addressInput => {console.log(venue.address); addressInput.target.value !== venue.address ? setChanges(true) : setChanges(false); console.log(changes)}}
                                                />
                                            </label>
                                        </div>
                                        <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                                        <div style={{ paddingInline: 10 }}>
                                            <label htmlFor="desc" className="label">
                                                Description:
                                                <textarea
                                                    name='desc'
                                                    id='desc'
                                                    placeholder="Enter Description"
                                                    className="editable"
                                                    defaultValue={venue?.desc && venue.desc}  
                                                    style={{height: 50}}
                                                    // multiline={true}
                                                    type='text'
                                                    onBlur={descInput => {console.log('desc:', venue.desc); descInput.target.value !== venue.desc ? setChanges(true) : setChanges(false); console.log(changes)}}
                                                />
                                            </label>
                                        </div>
                                        <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                                        <div style={{ paddingInline: 10 }}>
                                            <label htmlFor="price" className="label">
                                                Price per hour: $
                                                <input
                                                    name='price'
                                                    id='price'
                                                    placeholder="Enter Price"
                                                    className="editable"
                                                    defaultValue={venue?.price && venue.price}
                                                    type='number'
                                                    onBlur={priceInput => {db.collection('venue').doc(venueId).get().then(doc => console.log(doc.data()));; priceInput.target.value !== venue.price ? setChanges(true) : setChanges(false); console.log(changes)}}
                                                />
                                            </label>
                                        </div>
                                        <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                                        {venueId !== 'new' && (
                                            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignSelf: 'center' }}>
                                                <button
                                                    type="button"
                                                    className="BrowseButton"
                                                    style={{ borderWidth: 0, color: 'var(--wht)', textAlign: 'center'}}
                                                    onClick={() => {
                                                        showAdd ? setShowAdd(false) : setShowAdd(true);
                                                    }}
                                                >
                                                    Add image <FiPlusSquare style={{marginInlineStart: 5}}/>
                                                </button>
                                                {showAdd && <label htmlFor="img" style={{}}>
                                                    {/* Choose a img image: */}
                                                    <input
                                                    style={{ width: 'auto', height: 'auto' }}
                                                    onBlur={imgInput=>{console.log(imgInput.target.value, '(', imgInput.target.value.length,')',  'changes:', changes, ); imgInput.target.value.length !== 0 ? setChanges(true) : setChanges(false)}}
                                                    type="file"
                                                    id="img"
                                                    name="img"
                                                    accept="image/png, image/jpeg">
                                                    </input>
                                                </label>}
                                                <div className="EditVenueImgs" >
                                                    {venue?.image && (
                                                        venue.image.map((img) =>
                                                            <div key={img}>
                                                                <img alt='Venue puctire'
                                                                    src={img}
                                                                    className='EditVenueImage'
                                                                    // style={{ width: 120, height: 120, margin: 5, borderRadius: 5, objectFit: 'cover', cursor: 'pointer'}}
                                                                    onClick={() => selImg ? setSelImg (null) : setSelImg(img)}
                                                                />
                                                            </div>  
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        {selImg && (
                                            <div
                                                style={{
                                                    display: 'flex', 
                                                    flexDirection: 'row',
                                                    justifyContent: 'space-around',
                                                    backgroundColor: 'var(--drg)',
                                                }}
                                            >
                                                <button
                                                    type='button '
                                                    style={{ color: 'var(--wht)', borderWidth: 0 }}
                                                    onClick={() => { setSelImg(null)
                                                    }}
                                                >
                                                    Done <FiCheckSquare />
                                                </button>
                                                <button
                                                    type='button'
                                                    style={{ color: 'var(--org)', borderWidth: 0 }}
                                                    onClick={() => { db.collection('venue').doc(venueId).update({cover: selImg}).then(()  => console.log('cover was changed'))
                                                    }}
                                                >
                                                    Replace <FiEdit />
                                                </button>
                                                <button
                                                    type='button'
                                                    style={{ borderWidth: 0, color: 'var(--red)' }}
                                                onClick={() => {
                                                    let filterImg = venue.image.filter((x) => x != selImg);
                                                    // console.log('filtered', filterImg, 'docid', docid);
                                                    db.collection('venue').doc(venueId).update({ image: filterImg }).then(() => {
                                                        // setScsMsg('Image was deleted');
                                                        // timeout = setTimeout(() => { setScsMsg(null); }, 3000);
                                                        console.log('image  was  deleted')
                                                    });
                                
                                                }}
                                                >
                                                    Delete <FiXSquare />
                                                </button>
                                            </div>
                                        )}
                                        {changes && (
                                            <button
                                                type='submit'
                                                className='BrowseButton'
                                                style={{  marginBlockStart: 10, }}
                                            >
                                                {venueId === 'new' ? 'Create event' : <p className='BrowseButton' >Save changes </p>}{venueId === 'new'
                                                    ? <FiPlusCircle style={{ marginInline: 5, }} className='BrowseButton' />
                                                    : <FiCheckCircle style={{ marginInline: 5, }} className='BrowseButton' />}
                                            </button>
                                        )}
                                        {venueId != 'new' && (
                                            <button
                                                type='submit'
                                                style={{ borderWidth: 0, alignSelf: 'center', marginTop: 5, color: 'red' }}
                                                onClick={() => {
                                                    setAlert({
                                                        title: 'Are you sure?',
                                                        comment: 'Delete Venue',
                                                        options: [
                                                            { text: 'No', style: 'cancel' },
                                                            {
                                                                text: 'Delete',
                                                                onClick: () => {
                                                                    deleteVenue(venue).then(() => {
                                                                        navigateTo('/Profile/dashboard');
                                                                    }).catch(error => { console.error(error) })
                                                                },
                                                                style: 'destructive',
                                                            },
                                                        ],
                                                    });
                                                }}
                                            >
                                                Delete Venue <FiXCircle />
                                            </button>
                                        )}
                                    </form>
                                </React.Fragment>
                            ) : (
                                <p style={{ color: 'var(--org)', marginInline: 10, fontSize: 16 }} >
                                    Search the name or address of your desired location, then select
                                    from the results to register your venue on PartyLive
                                </p>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}